import "../../css/FormularioActor.css";

export default function Confirmacion({funcionConfirmar, funcionCancelar, titulo, mensaje, informativo}){

    //#region HOOKS STATE
    //==========================================================================================

    // Estados de contenido

    // Estados de validación

    //#endregion

    //#region HOOKS EFFECT
    //==========================================================================================    

    //#endregion

    //#region HANDLERS
    //==========================================================================================
    
    //#endregion

    //#region FUNCIONES
    //==========================================================================================

    // FUNCIONES ASÍNCRONAS

    // Ejecutar función recibida como parámetro
    const ejecutarFuncion = async () => {
        funcionConfirmar();
        funcionCancelar();
    }
    //#endregion

    const GenerarBotonesModal = () => {
        if(informativo == true){
            return (
                <div className="p-2 d-flex justify-content-around">
                    <button onClick={funcionCancelar} className="btn btn-secondary">Cerrar</button>
                </div>
            );
        }else{
            return (
                <div className="p-2 d-flex justify-content-around">
                    <button onClick={funcionCancelar} className="btn btn-secondary">Cancelar</button>
                    <button onClick={ejecutarFuncion} className="btn btn-primary">Confirmar</button>
                </div>
            );
        }
    }
    //#region CONTENIDO
    //==========================================================================================
    return(<>
    <div id="modal-actor" className="d-flex justify-content-center align-items-center">
        <div id="formulario-registro" className="rounded-3">
            <div className="bg-primary text-white p-2 fs-4 rounded-top-2">
                {titulo}
            </div>
            <div className="p-2">
                <div className="row">
                    <div className="px-4 py-3 col-12">
                        {mensaje}
                    </div>
                    {GenerarBotonesModal()}
                </div>
            </div>
        </div>
    </div>
    </>);
    //#endregion
}

//#region CONSTANTES
//==========================================================================================
//#endregion
